import React, { useState, useEffect } from "react";
import { $t } from '@/modules/i18n';

export default ({ message = {} }) => {
  const [ active, setActive ] = useState(message.sections ? message.sections[0] : {})

  function toggleSection(index) {
    setActive(message.sections[index]);
  }

  useEffect(() => {
    message && message.sections && !Object.keys(active).length && setActive(message.sections[0])
  })

  return (
    <section id="faq">
      <h2 className="section-title">{$t(message.title)}</h2>
      <div className="content">
        <ul className="faq-sections">
        {
          (message.sections || []).map((section, index) => (
            <li className={`faq-section-title${section.title === active.title ? ' active' : ''}`} onClick={() => toggleSection(index)} key={section.title}>{$t(section.title)}</li>
          ))
        }
        </ul>
        <div className="list" id="faq">
        {
          (active.list || []).map((section, index) => (
            <div className="item" key={section.question}>
              <div className="cover collapsed" id={`faq-${index}`} data-toggle="collapse" data-target={`#ans-${index}`} aria-expanded="true" aria-controls={`ans-${index}`}>
                {$t(section.question)}
              </div>
              <div id={`ans-${index}`} className="answers collapse" aria-labelledby={`faq-${index}`} data-parent="#faq">
              {
                section.desc.map(desc => <p dangerouslySetInnerHTML={{ __html: $t(desc) }} key={desc} />)
              }
              </div>
            </div>
          ))
        }
        </div>
      </div>
    </section>
  )
};
